var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "invoice-add-wrapper" },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center mb-1" },
        [
          _vm.loading
            ? _c("b-spinner", {
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "success", label: "Spinning", block: "" },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitForm($event)
                },
                change: _vm.submitFormText,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "invoice-add" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", xl: "12", md: "12" } },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "invoice-preview-card",
                          attrs: { "no-body": "" },
                        },
                        [
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-end print_button",
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.print },
                                    },
                                    [_vm._v("Print")]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mx-3",
                                      attrs: { variant: "success" },
                                      on: { click: _vm.downloadAsDoc },
                                    },
                                    [_vm._v("Download as Word")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-number-date mt-md-0 mt-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-md-end mb-1",
                                        },
                                        [
                                          _c(
                                            "h4",
                                            {
                                              staticClass: "invoice-title mr-1",
                                            },
                                            [_vm._v("Reference")]
                                          ),
                                          _c(
                                            "b-input-group",
                                            {
                                              staticClass:
                                                "input-group-merge invoice-edit-input-group disabled",
                                            },
                                            [
                                              _c(
                                                "b-input-group-prepend",
                                                { attrs: { "is-text": "" } },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: { icon: "HashIcon" },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "invoice-data-id",
                                                  readonly: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.templateId.reference,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.templateId,
                                                      "reference",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "templateId.reference",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center mb-1",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v("Start Date: "),
                                          ]),
                                          _c("flat-pickr", {
                                            staticClass:
                                              "form-control invoice-edit-input",
                                            attrs: { disabled: "" },
                                            model: {
                                              value: _vm.templateId.startDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.templateId,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "templateId.startDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(" Due Date: "),
                                          ]),
                                          _c("flat-pickr", {
                                            staticClass:
                                              "form-control invoice-edit-input",
                                            attrs: {
                                              required: "",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.templateId.dueDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.templateId,
                                                  "dueDate",
                                                  $$v
                                                )
                                              },
                                              expression: "templateId.dueDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0 sale_person" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "mt-md-0 mt-3 d-flex align-items-center",
                                      attrs: {
                                        cols: "12",
                                        md: "6",
                                        order: "2",
                                        "order-md": "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "text-nowrap mr-50",
                                          attrs: {
                                            for: "invoice-data-sales-person",
                                          },
                                        },
                                        [_vm._v("Staff:")]
                                      ),
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.optionsSalesPerson,
                                          required: "",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.templateId.assignedTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.templateId,
                                              "assignedTo",
                                              $$v
                                            )
                                          },
                                          expression: "templateId.assignedTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("hr", { staticClass: "invoice-spacing" }),
                          _c(
                            "h4",
                            {
                              staticClass:
                                "my-2 d-flex justify-content-start mx-3",
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.product.description)),
                              ]),
                            ]
                          ),
                          _c(
                            "b-card-body",
                            {
                              staticClass: "invoice-padding form-item-section",
                              staticStyle: { "text-align": "left" },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.renderedTemplate),
                                },
                              }),
                            ]
                          ),
                          _c(
                            "b-card-body",
                            {
                              staticClass:
                                "invoice-padding form-item-section note-section",
                              staticStyle: { "text-align": "left" },
                              attrs: { title: "Note for Service Request" },
                            },
                            [
                              _c("div", {
                                attrs: { readonly: "" },
                                domProps: {
                                  innerHTML: _vm._s(_vm.renderedTemplateNote),
                                },
                              }),
                            ]
                          ),
                          _c("hr", { staticClass: "invoice-spacing" }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }